import React from 'react';

const NoticeDetailSkeleton: React.FC = () => {
    return (
        <main className="bg-gray-50 min-h-screen overflow-y-auto">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6">
                <div className="max-w-4xl mx-auto">
                    {/* 헤더 영역 스켈레톤 */}
                    <div className="mb-6">
                        {/* 뒤로가기 버튼 스켈레톤 */}
                        <div className="mb-6 animate-pulse">
                            <div className="h-6 bg-gray-300 rounded w-24"></div>
                        </div>

                        {/* 제목 영역 스켈레톤 */}
                        <div className="flex items-center gap-3 mb-4 animate-pulse">
                            <div className="h-6 bg-gray-300 rounded-full w-16"></div>
                            <div className="h-8 bg-gray-300 rounded w-3/4"></div>
                        </div>

                        {/* 작성일시 스켈레톤 */}
                        <div className="animate-pulse">
                            <div className="h-4 bg-gray-300 rounded w-48"></div>
                        </div>
                    </div>

                    {/* 내용 영역 스켈레톤 */}
                    <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
                        <div className="p-6">
                            <div className="animate-pulse space-y-4">
                                {/* 내용 텍스트 스켈레톤 */}
                                <div className="space-y-3">
                                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                                    <div className="h-4 bg-gray-300 rounded w-5/6"></div>
                                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                                    <div className="h-4 bg-gray-300 rounded w-4/5"></div>
                                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                                    <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                                </div>
                                
                                {/* 문단 구분 */}
                                <div className="pt-4 space-y-3">
                                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                                    <div className="h-4 bg-gray-300 rounded w-5/6"></div>
                                </div>
                                
                                {/* 추가 문단 */}
                                <div className="pt-4 space-y-3">
                                    <div className="h-4 bg-gray-300 rounded w-4/5"></div>
                                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                                    <div className="h-4 bg-gray-300 rounded w-3/5"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 하단 액션 영역 스켈레톤 */}
                    <div className="mt-6 flex justify-center animate-pulse">
                        <div className="h-10 bg-gray-300 rounded-lg w-32"></div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default NoticeDetailSkeleton;
